import { TbDoorExit } from 'react-icons/tb'

import { useAppSelector } from '../hooks/useAppSelector'
import { usePromotersStayingTimeContext } from '../hooks/usePromotersStayingTimeContext'
import { Role } from '../interfaces/rolesEnum'
import { cn } from '../libs/tailwindMerge'
import { Button } from './Button'
import { PromotersStayingTimeCounter } from './PromotersStayingTimeCounter'

export function FloatingPromotersStayingTimeCounter() {
  const { activeCycle, endCurrentCycle, isLoadingGeolocation } = usePromotersStayingTimeContext()
  const { profile } = useAppSelector(state => state.auth)
  return (
    <div className={cn(
      'flex-col fixed left-4 bottom-4 z-[9999]',
      activeCycle && (profile?.role === Role.PROMOTER || profile?.role === Role.ROOT)
        ? 'flex'
        : 'hidden',
    )}
    >
      <Button
        title="Informar saída da loja"
        className="flex flex-col w-fit shadow-md p-3 rounded-full bg-orange-600 md:bg-orange-400 hover:bg-orange-600"
        onClick={() => endCurrentCycle()}
        disabled={isLoadingGeolocation}
      >
        <TbDoorExit />
        <PromotersStayingTimeCounter />
      </Button>
    </div>
  )
}
